import script from "./UpdatePasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePasswordView.vue?vue&type=script&setup=true&lang=js"

import "./UpdatePasswordView.vue?vue&type=style&index=0&id=1798d44f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1798d44f"]])

export default __exports__